export const SIGN_IN_PATH = "/connexion";

/** The sign-in screen's URL, remembering where to come back to. */
export function signInUrl(from: string): string {
  if (from.startsWith(SIGN_IN_PATH)) return from;
  return `${SIGN_IN_PATH}?retour=${encodeURIComponent(from)}`;
}

/**
 * Where to go once signed in. Only a path on this site: a crafted link must
 * not turn the sign-in page into a redirect to somewhere else.
 */
export function returnPath(search: string): string {
  const target = new URLSearchParams(search).get("retour") ?? "/";
  if (!target.startsWith("/") || target.startsWith("//") || target.startsWith("/\\")) return "/";
  if (target.startsWith(SIGN_IN_PATH)) return "/";
  return target;
}
